<ejs-dialog 
  target=".dialogs" 
  class="autoheight-dialog" 
  [visible]='visible()' 
  [animationSettings]='dialogService.getAnimationSettings()' 
  [resizeHandles]='dialogService.getResizeHandleDirection()' 
  [position]='dialogService.getPosition()' 
  [isModal]="true" 
  [allowDragging]="false" 
  [width]="'40%'" 
  [height]="'auto'" 
  [zIndex]="999" 
  [showCloseIcon]="true" 
  (close)="close()"
  >
  <ng-template #header>
    <div class="d-flex align-items-center justify-content-center">
      <app-headline 
        [title]="('CHATNEWUSERCHAT' | translate)" 
        [type]="'h5'" 
        [class]="'text-primary'"
        >
      </app-headline>
      <app-tooltip 
        [icon]="'help'" 
        [iconClass]="'fs-5 p-1'" 
        [text]="('CHATNEWUSERCHATHELP' | translate)" 
        [width]="'300px'" 
        [height]="'100px'" 
        [cssClass]="'helpTooltip p-2'" 
        [opensOn]="'Click'"
        >
      </app-tooltip>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="d-flex flex-column h-100 p-3">
      <app-form-user-group-mail 
        [can]="'chat'"
        [method]="'user'" 
        [singleSelection]="true" 
        [allowEmails]="false" 
        [allowPush]="false" 
        [user]="participantsUserIDs()"
        (userChange)="participantsUserIDs.set($event)" 
        (userModelChange)="participantsUserModels.set($event)"
        >
      </app-form-user-group-mail>
    </div>
  </ng-template>
</ejs-dialog>
